import { render, staticRenderFns } from "./TaxFundEntry.vue?vue&type=template&id=631892b1&scoped=true"
import script from "./TaxFundEntry.vue?vue&type=script&lang=js"
export * from "./TaxFundEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631892b1",
  null
  
)

export default component.exports